import { PhotoResponse } from './photo';
import { Product } from './product';

export interface PhotoAttachment {
  overriddenCreatedOn: string | number;
  photos: PhotoResponse[];
  products?: Product[];
  type?: number;
}

export interface PhotoAttachmentDto {
  formattedDate?: string;
  photos: PhotoResponse[];
  productString?: string;
  products?: Product[];
  overriddenCreatedOn?: string | number;
  type?: string;
}
